import {Component, OnDestroy, OnInit} from '@angular/core';
import {ResourceViewerService} from './resource-viewer.service';
import {
    EventRecorderService
} from '../../../../../../micromate-learn-lib/src/lib/services/event/event-recorder.service';
import {
    ResourceOpenedFromType
} from '../../../../../../micromate-learn-lib/src/lib/services/event/ResourceOpenEventPayload';
import {ActivatedRoute, Router} from '@angular/router';
import {take} from 'rxjs/operators';

@Component({
    selector: 'mm-resource-viewer',
    templateUrl: './resource-viewer.component.html',
    styleUrls: ['./resource-viewer.component.scss'],
    standalone: false
})
export class ResourceViewerComponent implements OnInit, OnDestroy {
    private hashchangeEventListener: EventListener = () => window.location.reload();
    public isAndroid = /android/i.test(window.navigator.userAgent);

    constructor(public resourceViewerService: ResourceViewerService,
                private route: ActivatedRoute,
                private router: Router,
                private eventRecorderService: EventRecorderService) {
    }

    public ngOnInit(): void {
        // TODO MIC-2094
        void this.asyncNgOnInit();
        window.addEventListener('hashchange', this.hashchangeEventListener);
    }

    public ngOnDestroy(): void {
        window.removeEventListener('hashchange', this.hashchangeEventListener);
    }

    private async asyncNgOnInit(): Promise<void> {
        const resourceId = this.route.snapshot.params['resourceId'] as string;
        const selectionId = this.route.snapshot.params['selectionId'] as string;
        const viewAsMicromateHtml = this.route.snapshot.queryParams['format'] === 'micromate-html';
        await this.recordResourceViewerOpenEvent(resourceId, selectionId);
        const resourceUrl$ = this.resourceViewerService.loadResource(resourceId, selectionId, viewAsMicromateHtml);
        if (this.isAndroid) {
            resourceUrl$
            .pipe(take(1))
            .subscribe(blobUrl => {
                const a = document.createElement('a');
                a.setAttribute('href', blobUrl);
                a.click(); // initiate opening
            })
        }
    }

    private async recordResourceViewerOpenEvent(resourceId: string, selectionId: string): Promise<void> {
        const openedFrom = this.route.snapshot.queryParams['opened-from'] as string;
        if (openedFrom === ResourceOpenedFromType.QA_SOURCE || openedFrom === ResourceOpenedFromType.QUESTION) {
            await this.eventRecorderService.recordResourceViewerOpen(ResourceOpenedFromType.QUESTION, resourceId, selectionId);
            await this.router.navigate([], {
                queryParams: {
                    'opened-from': undefined,
                }, queryParamsHandling: 'merge'
            });
        }
    }

}
